import type { SvgProps } from "components/icons/types";

export const Undo = (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.9333 3.81133H1.86198L4.73331 0.941333L3.78798 0L0.487977 3.29933C0.175526 3.61188 0 4.03573 0 4.47767C0 4.91961 0.175526 5.34345 0.487977 5.656L3.78798 8.95667L4.73331 8.014L1.86664 5.14733H13.9333C14.1143 5.13519 14.2928 5.19486 14.43 5.31342C14.5673 5.43197 14.6523 5.59985 14.6666 5.78067V13.1807C14.6522 13.3614 14.5671 13.5291 14.4298 13.6475C14.2926 13.7659 14.1142 13.8255 13.9333 13.8133H1.33331V15.1467H13.9333C14.4681 15.159 14.986 14.9588 15.3735 14.5899C15.7609 14.221 15.9862 13.7135 16 13.1787V5.778C15.9858 5.24344 15.7604 4.73629 15.373 4.36766C14.9856 3.99902 14.4679 3.79897 13.9333 3.81133V3.81133Z"
      fill="currentColor"
    />
  </svg>
);
